import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/fraunces/500.css";
import "@fontsource/fraunces/600.css";
import "./index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initPwa } from "./lib/pwa";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Elemento #root ausente no index.html");

// Manifesto do aluno + service worker + captura do instalador nativo — antes do
// React, porque o `beforeinstallprompt` pode disparar cedo. Falha aqui não pode
// derrubar o portal.
try {
  initPwa();
} catch (err) {
  console.warn("[pwa] init falhou", err);
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
